
const initialState = {};

const BaseReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'BASE':
            //console.log('BaseReducer.state', state, action.payload, typeof action.payload == 'object');
            //console.log('UiReducer.action.payload', action.payload);
            return { ...state, ...((typeof action.payload == 'object') ? action.payload : {}) };
        default:
            return state;
    }
}

export default BaseReducer;